module.exports = __webpack_public_path__ + "media/images/checkout/challenger/minus-76b61f9767bf764eb62d243de17ad950.svg";